import type { ReactNode } from 'react';
import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
type ImagePlaceholderProps = {
  aspectRatio: number;
  children: ReactNode;
  className?: string;
};
export const ImagePlaceholder = ({
  aspectRatio = 0,
  children,
  className,
}: ImagePlaceholderProps) => (
  <span data-testid="img-placeholder" className={classnames('block h-full w-full', className)}>
    <span
      className="relative block h-full w-full"
      style={{
        paddingBottom: `${aspectRatio}%`,
      }}
    >
      <span className="absolute inset-0">{children}</span>
    </span>
  </span>
);
